import { Component, OnInit } from '@angular/core';
import { ClaimKey } from '../../../../models/api/core/claim-key';
import {
  CaseInformationResponse,
  DefenseAttorneyResponse,
  LegalDashboardResponse,
  PlaintiffAttorneyResponse,
} from '../../../../models/api/view/claim/details/legal/legal-response';
import { BaseComponent } from '../../../base/base.component';
import { PageHeaderComponent } from '../../../core/labels/page-header.component';
import { CardComponent } from '../../../core/panels/card.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';

@Component({
  selector: 'app-legal',
  imports: [
    DetailPanelComponent,
    DetailItemComponent,
    CardComponent,
    PageHeaderComponent,
  ],
  template: `
    <app-page-header label="Legal" />
    <div class="tw-flex tw-gap-4">
      <div class="tw-basis-1/3">
        <app-card label="Plaintiff Attorney">
          <app-detail-panel [dataSource]="plaintiffAttorney">
            <app-detail-item label="Name" name="patName" />
            <app-detail-item label="Firm" name="patFirm" />
            <app-detail-item label="Representing" name="patRepresent" />
            <app-detail-item label="Address" name="address" />
            <app-detail-item label="Country" name="patCountry" />
            <app-detail-item label="County" name="patCounty" />
            <app-detail-item label="Phone" name="patPhone" />
            <app-detail-item label="Email" name="patEmail" />
            <app-detail-item label="Fax" name="patFax" />
            <app-detail-item
              label="Attorney Representation Date"
              name="dateAttDis"
              format="d"
            />
          </app-detail-panel>
        </app-card>
      </div>

      <div class="tw-basis-1/3">
        <app-card label="Defense Attorney">
          <app-detail-panel [dataSource]="defenseAttorney">
            <app-detail-item label="Name" name="name1" />
            <app-detail-item label="Firm" name="firm1" />
            <app-detail-item label="Representing" name="representing1" />
            <app-detail-item label="Address" name="address1" />
            <app-detail-item label="Country" name="country1" />
            <app-detail-item label="County" name="county1" />
            <app-detail-item label="Phone" name="phone1" />
            <app-detail-item label="Email" name="email1" />
            <app-detail-item label="Fax" name="fax1" />
          </app-detail-panel>
        </app-card>
      </div>

      <div class="tw-basis-1/3">
        <app-card label="2nd Defense Attorney">
          <app-detail-panel [dataSource]="defenseAttorney">
            <app-detail-item label="Name" name="name2" />
            <app-detail-item label="Firm" name="firm2" />
            <app-detail-item label="Representing" name="representing2" />
            <app-detail-item label="Address" name="address2" />
            <app-detail-item label="Country" name="country2" />
            <app-detail-item label="County" name="county2" />
            <app-detail-item label="Phone" name="phone2" />
            <app-detail-item label="Email" name="email2" />
            <app-detail-item label="Fax" name="fax2" />
          </app-detail-panel>
        </app-card>
      </div>
    </div>

    <div class="tw-flex tw-gap-4 tw-pt-8">
      <div class="tw-basis-2/3">
        <app-card label="Case Information">
          <div class="tw-flex app-gap">
            <div class="tw-basis-1/2">
              <app-detail-panel [dataSource]="caseInformation" class="tw-grow">
                <app-detail-item label="Case #" name="caseNumber" />
                <app-detail-item
                  label="In Litigation?"
                  name="litigation"
                  format="b"
                />
                <app-detail-item
                  label="Date"
                  name="litigationDate"
                  format="d"
                />
                <app-detail-item
                  label="Small Claims Court?"
                  name="smallClaimsCourt"
                  format="b"
                />
                <app-detail-item label="Verdict" name="verdict" />
                <app-detail-item label="Legal strategy" name="legalStrategy" />
                <app-detail-item label="Resolved?" name="resolved" format="b" />
                <app-detail-item label="Date" name="resolvedDate" format="d" />
                <app-detail-item
                  label="Date suit filed with court"
                  name="suitDate1"
                  format="d"
                />
                <app-detail-item
                  label="Date of service to client"
                  name="clientNotify"
                  format="d"
                />
                <app-detail-item
                  label="Service of process"
                  name="serviceOfProcess"
                />
                <app-detail-item
                  label="Admin notified"
                  name="adminNotify"
                  format="d"
                />
                <app-detail-item
                  label="Answer due date"
                  name="answerDate1"
                  format="d"
                />
                <app-detail-item
                  label="Answer not required"
                  name="answerNotRequired"
                  format="b"
                />
                <app-detail-item
                  label="Reason"
                  name="answerNotRequiredReason"
                />
                <app-detail-item
                  label="Extension"
                  name="extension"
                  format="b"
                />
              </app-detail-panel>
            </div>
            <div class="tw-basis-1/2">
              <app-detail-panel [dataSource]="caseInformation" class="tw-grow">
                <app-detail-item label="Stayed" name="stayed" format="b" />
                <app-detail-item label="Reason" name="stayedReason" />
                <app-detail-item
                  label="Answer filed date"
                  name="entered"
                  format="d"
                />

                <app-detail-item
                  label="Motion Date"
                  name="motionDate1"
                  format="d"
                />
                <app-detail-item
                  label="Mediation Date"
                  name="mediationDate"
                  format="d"
                />
                <app-detail-item label="Time" name="mediationTime" format="t">
                  <ng-template #value let-data>
                    {{
                      data?.mediationTime !== '0000' ? data?.mediationTime : ''
                    }}
                  </ng-template>
                </app-detail-item>
                <app-detail-item
                  label="Mediation Result"
                  name="mediationResult"
                />

                <app-detail-item
                  label="Trial Date"
                  name="trialDate1"
                  format="d"
                />
                <app-detail-item label="Time" name="trialTime1" format="t">
                  <ng-template #value let-data>
                    {{ data?.trialTime1 !== '0000' ? data?.trialTime1 : '' }}
                  </ng-template>
                </app-detail-item>
                <app-detail-item label="Trial Result" name="trialResult" />
                <app-detail-item label="Docket" name="docked" />
                <app-detail-item label="Court" name="courtName" />
                <app-detail-item label="Lawsuit State" name="lawsuitState" />
                <app-detail-item
                  label="Punitive Damages?"
                  name="punitiveDamages"
                  format="b"
                />
                <app-detail-item label="Escrow" name="escrowAmt" format="c" />
                <app-detail-item
                  label="Fees In Escrow?"
                  name="feesinEscrow"
                  format="b"
                />
              </app-detail-panel>
            </div>
          </div>
        </app-card>
      </div>
      <div class="tw-basis-1/3">
        <app-card label="Appeal Information">
          <app-detail-panel [dataSource]="caseInformation">
            <app-detail-item label="Appeal Case #" name="appealCaseNumber" />
            <app-detail-item label="Date Due" name="dateDue" format="d" />
            <app-detail-item label="Suit Date" name="suitDate2" format="d" />
            <app-detail-item label="Notify Date" name="notifyDate" format="d" />
            <app-detail-item label="Level" name="level" />
            <app-detail-item
              label="Motion Date"
              name="motionDate2"
              format="d"
            />
            <app-detail-item label="Trial Date" name="trialDate2" format="d" />
            <app-detail-item label="Result" name="result" />
            <app-detail-item label="Trial Time" name="trialTime2" format="t">
              <ng-template #value let-data>
                {{ data?.trialTime2 !== '0000' ? data?.trialTime2 : '' }}
              </ng-template>
            </app-detail-item>
            <app-detail-item
              label="Answer Date"
              name="answerDate2"
              format="d"
            />
          </app-detail-panel>
        </app-card>
      </div>
    </div>
  `,
  styles: ``,
})
export class LegalComponent extends BaseComponent implements OnInit {
  claim = this.view.currentClaim();
  legalDashboard: LegalDashboardResponse;
  plaintiffAttorney: PlaintiffAttorneyResponse & { address?: string };
  defenseAttorney: DefenseAttorneyResponse;
  caseInformation: CaseInformationResponse;

  constructor() {
    super();
  }

  async ngOnInit() {
    this.view.showLoading();
    const claimKey: ClaimKey = {
      recordId: this.claim.recordId,
      recordSource: this.claim.recordSource,
    };

    const legalDashboard = await this.api.legalController.get(claimKey);
    if (!legalDashboard.plaintiffAttorneyResponse) {
      this.plaintiffAttorney = null;
    } else {
      const pa = legalDashboard.plaintiffAttorneyResponse;
      this.plaintiffAttorney = {
        ...pa,
        address: [
          pa.patAddr1,
          pa.patAddr2,
          [pa.patCity, pa.patState, pa.patZip].filter(Boolean).join(', '),
        ]
          .filter(Boolean)
          .join(' '),
      };
    }
    this.defenseAttorney = legalDashboard.defenseAttorneyResponse;
    this.caseInformation = legalDashboard.caseInformationResponse;
    this.view.hideLoading();
  }
}
